import React, { useState, useCallback } from 'react';
import { Profile } from '@/types/auth';
import { BentoGrid } from './BentoGrid';
import { EditModeToggle } from './EditModeToggle';
import { WidgetPalette } from './WidgetPalette';
import { useBentoConfig } from '@/hooks/use-bento-config';

interface BentoProfileContainerProps {
  profile: Profile;
  bentoConfig: any;
  isOwnProfile: boolean;
}

const defaultLayout = [
  { i: 'profile-header', x: 0, y: 0, w: 3, h: 2, minW: 2, minH: 1 },
  { i: 'bio', x: 3, y: 0, w: 2, h: 1, minW: 1, minH: 1 },
  { i: 'stats', x: 5, y: 0, w: 1, h: 1, minW: 1, minH: 1 },
  { i: 'social-links', x: 3, y: 1, w: 1, h: 1, minW: 1, minH: 1 },
  { i: 'banner', x: 4, y: 1, w: 2, h: 2, minW: 1, minH: 1 },
  { i: 'contact', x: 0, y: 2, w: 1, h: 1, minW: 1, minH: 1 },
  { i: 'achievements', x: 1, y: 2, w: 1, h: 1, minW: 1, minH: 1 },
  { i: 'gallery', x: 2, y: 2, w: 4, h: 2, minW: 2, minH: 1 },
];

export const BentoProfileContainer: React.FC<BentoProfileContainerProps> = ({
  profile,
  bentoConfig,
  isOwnProfile,
}) => {
  const [isEditMode, setIsEditMode] = useState(false);
  const [showWidgetPalette, setShowWidgetPalette] = useState(false);
  
  const { updateLayout, isUpdating } = useBentoConfig(profile.id);

  const layout = (bentoConfig?.layout_config && bentoConfig.layout_config.length > 0) 
    ? bentoConfig.layout_config 
    : defaultLayout;

  const handleLayoutChange = useCallback((newLayout: any[]) => {
    if (isEditMode && isOwnProfile) {
      updateLayout(newLayout);
    }
  }, [isEditMode, isOwnProfile, updateLayout]);

  const toggleEditMode = () => {
    setIsEditMode(!isEditMode);
    if (!isEditMode) {
      setShowWidgetPalette(false);
    }
  };

  return (
    <div className="relative min-h-screen p-4 md:p-6 lg:p-8">
      {/* Edit Mode Controls */}
      {isOwnProfile && (
        <>
          <EditModeToggle 
            isEditMode={isEditMode}
            onToggle={toggleEditMode}
            onShowPalette={() => setShowWidgetPalette(true)}
            isUpdating={isUpdating}
          />
          
          {showWidgetPalette && (
            <WidgetPalette 
              onClose={() => setShowWidgetPalette(false)}
              currentWidgets={layout.map(item => item.i)}
              onAddWidget={(widgetId) => {
                // Add widget logic here
                console.log('Add widget:', widgetId);
              }}
            />
          )}
        </>
      )}

      {/* Bento Grid */}
      <BentoGrid
        profile={profile}
        layout={layout}
        isEditMode={isEditMode}
        onLayoutChange={handleLayoutChange}
      />
    </div>
  );
};